import { defineStore } from 'pinia'
import state from '@/stores/organizations/state'
import actionsStore from '@/stores/organizations/actions'
import gettersStore from '@/stores/organizations/getters'
import mutationsStore from '@/stores/organizations/mutations'

export const useOrganizationStore = defineStore('organization', () => {
  const getters = gettersStore(state)
  const mutations = mutationsStore(state)
  const actions = actionsStore(mutations)
  return {
    state,
    getters,
    mutations,
    actions,
  }
})
